import { useModelService } from 'services/model/model.service';
import { customKpi, measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useCountryDashboardKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [gmvMeasure, retRateMeasure] = getMeasures(['ordGmvVal', 'retQtyRateExpOD']);

  return [
    customKpi('active_countries', {
      titleId: 'insights.country_tab.active_countries_header',
      descriptionId: 'insights.country_tab.active_countries_description',
    }),
    measureKpi(gmvMeasure),
    measureKpi(retRateMeasure),
    customKpi('avgSoldItemsPerProduct', {
      titleId: 'model.calculated.metric.avgSoldItemsPerProduct.name',
      descriptionId: 'model.calculated.metric.avgSoldItemsPerProduct.description',
    }),
    customKpi('slsPrdNum', {
      titleId: 'model.metric.slsPrdNum.name',
      descriptionId: 'model.metric.slsPrdNum.description',
    }),
    customKpi('slsQty', {
      titleId: 'model.metric.slsQty.name',
      descriptionId: 'model.metric.slsQty.description',
    }),
  ];
}

export function CountryDashboardInfoContent() {
  const kpis = useCountryDashboardKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulDescriptionId="insights.country_tab.info.content.why_is_this_view_useful_description"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
